import { render, staticRenderFns } from "./TrainIndex.vue?vue&type=template&id=ae5fb300&scoped=true"
import script from "./TrainIndex.vue?vue&type=script&lang=js"
export * from "./TrainIndex.vue?vue&type=script&lang=js"
import style0 from "./TrainIndex.vue?vue&type=style&index=0&id=ae5fb300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5fb300",
  null
  
)

export default component.exports